export const Errors = {
    notSerializableRefCall: (prop, arg) => {
        throw new Error(`
The input provided to '${prop.toString()}' is not serializable. Serialization is required to ensure that the data can be safely transferred to the skin implementation. 
The following types of data are considered non-serializable and cannot be processed:

- Functions
- DOM elements
- Class instances
- Circular references
- Symbols
- BigInt values

In the following execution we detected :
~~~~~~~~
${arg} 
~~~~~~~~
as not serializable.

To resolve this issue, please ensure that all inputs passed to '${prop.toString()}' are in a serializable format.
This typically includes primitive types (strings, numbers, booleans), arrays, and plain objects. 
If you need to include complex data types, consider converting them to a serializable structure before passing them to the function.
Or use Myop message that support it: CustomRefMessage, AddEventListenerMessage or ExecuteScriptMessage.

Suggested Fix:
1. Remove or replace non-serializable values from your input.
2. If using objects, ensure they do not contain any functions or circular references.
3. Convert any class instances to plain objects or JSON-compatible formats.
4. Use dedicated Myop message.

For more details on serialization and Myop message examples, refer to https://docs.myop.dev\.

`);
    }
}

